export const RequestFetch = (method, objecbody, bearer) => {
  return {
    method: method,
    headers: bearer
      ? {
          Authorization: `Bearer ${bearer}`,
          "content-type": "application/json",
          "Cache-Control": "no-cache,no-store,must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        }
      : {
          "content-type": "application/json",
          "Cache-Control": "no-cache,no-store,must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
    body: JSON.stringify(objecbody),
  };
};
